const body = document.querySelectorAll("body")[0];

window.onload = () => {
  const createPop = document.querySelectorAll("#size-popup");
  if(createPop.length != 0){
    createPop[0].addEventListener("click", function(){
      checkCookie(tipoProducto,'');
    }, false);
    console.log(tipoProducto);
  }
}

//Con esta función creamos el código HTML del PopUp, dependiendo de la variable que reciba se creará un Po-Up para Top, otro para bottom y otro para OnePiece
function createPopUp($talla, $tipo, $color) {
  event.preventDefault();
  var popup = document.createElement("div");
  popup.classList.add("pop-up-container");
  popup.id = "pop-up-container";
  //Como queremos distiguir entre varios tipos de tallaje creamos distitnos códigos HTML
  if($tipo == 'TOP SWIM'){
    popup.innerHTML= " <div class='box-container'> <div id='close' class='close'></div> <div class='contenedorPrincipal'> <div class='modalTitle' modal='sizeTool'><h3 class='dark'>TE AYUDAMOS A ENCONTRAR TU TALLA</h3></div><div class = 'modalP'> <p>TOP DE SWIMWEAR</p> </div> <div class='modalImages'> <div class='cell-image'> <img src='https://cdn.shopify.com/s/files/1/2496/0966/files/rony_1.jpg?v=1627649889' alt='Video' title='Video'></div><div class='cell-image'><img src='https://cdn.shopify.com/s/files/1/2496/0966/files/erin_1.jpg?v=1627649952' alt='Video' title='Video'> </div> </div></div> <div class='selecciona-talla'><p>Selecciona tu talla de pecho</p></div><div class='container-input'> <form onsubmit='event.preventDefault()'> <div class='input-popup'> <div class='cell-form'> <select id='copa' > <option >80-85</option> <option >90-95</option> <option>mayor que 95</option> </select> </div> </div> <div class='cell-button'><div id='talla-actual'><p>" + $talla + "</p></div> <button id='calculateFromModalPdp' type='submit' class='button wide'>ENCONTRAR MI TALLA </button> </div>  </form> </div></div>";
  }else if($tipo == 'BOTTOM'){
    popup.innerHTML= " <div class='box-container'> <div id='close' class='close'></div> <div class='contenedorPrincipal'> <div class='modalTitle' modal='sizeTool'> <h3 class='dark'>TE AYUDAMOS A ENCONTRAR TU TALLA </h3> </div> <div class='modalP'><p>SWIMWEAR BOTTOM</p></div> <div class='modalImages'> <div class='cell-image'> <img src='https://cdn.shopify.com/s/files/1/2496/0966/files/kim1.jpg?v=1627650153' alt='Video' title='Video' /> </div> <div class='cell-image'> <img src='https://cdn.shopify.com/s/files/1/2496/0966/files/kim2.jpg?v=1627650154' alt='Video' title='Video' /> </div> </div> </div> <div class='selecciona-talla'><p>SELECCIONA TU TALLA DE PANTALÓN</p></div> <div class='container-input'> <form onsubmit='event.preventDefault()'> <div class='input-popup'> <div class='cell-form'> <select id='copa'> <option>32-34</option> <option>36-38</option> <option>40-42</option> </select> </div> </div> <div class='cell-button'> <div id='talla-actual'><p>" + $talla + "</p></div> <button id='calculateFromModalPdp' type='submit' class='button wide'> ENCONTRAR MI TALLA </button> </div> </form> </div> </div>";
  }else if($tipo == 'SHORTS' || $tipo == 'LEGGINGS'){
    popup.innerHTML= " <div class='box-container'> <div id='close' class='close'></div> <div class='contenedorPrincipal'> <div class='modalTitle' modal='sizeTool'> <h3 class='dark'>TE AYUDAMOS A ENCONTRAR TU TALLA </h3> </div> <div class='modalP'><p>ACTIVEWEAR BOTTOM</p></div> <div class='modalImages'> <div class='cell-image'> <img src='https://cdn.shopify.com/s/files/1/2496/0966/files/activebottom_1.jpg?v=1627650411' alt='Video' title='Video' /> </div> <div class='cell-image'> <img src='https://cdn.shopify.com/s/files/1/2496/0966/files/activebottom_2.jpg?v=1627650411' alt='Video' title='Video' /> </div> </div> </div> <div class='selecciona-talla'><p>SELECCIONA TU TALLA DE PANTALÓN</p></div> <div class='container-input'> <form onsubmit='event.preventDefault()'> <div class='input-popup'> <div class='cell-form'> <select id='copa'> <option>32-34</option> <option>36-38</option> <option>40-42</option> </select> </div> </div> <div class='cell-button'> <div id='talla-actual'><p>" + $talla + "</p></div> <button id='calculateFromModalPdp' type='submit' class='button wide'> ENCONTRAR MI TALLA </button> </div> </form> </div> </div>";
  }
  else if($tipo == 'TOP ACTIVE'){
    popup.innerHTML= " <div class='box-container'> <div id='close' class='close'></div> <div class='contenedorPrincipal'> <div class='modalTitle' modal='sizeTool'> <h3 class='dark'>TE AYUDAMOS A ENCONTRAR TU TALLA </h3> </div> <div class='modalP'><p>ACTIVEWEAR TOP</p></div> <div class='modalImages'> <div class='cell-image'> <img src='https://cdn.shopify.com/s/files/1/2496/0966/files/activetop.jpg?v=1627650288' alt='Video' title='Video' /> </div> <div class='cell-image'> <img src='https://cdn.shopify.com/s/files/1/2496/0966/files/activetop2.jpg?v=1627650288' alt='Video' title='Video' /> </div> </div> </div> <div class='selecciona-talla'><p>SELECCIONA TU TALLA DE PECHO</p></div> <div class='container-input'> <form onsubmit='event.preventDefault()'> <div class='input-popup'> <div class='cell-form'> <select id='copa'> <option>80-90</option> <option>95-100</option> <option>mayor que 100</option> </select> </div> </div> <div class='cell-button'> <div id='talla-actual'><p>" + $talla + "</p></div> <button id='calculateFromModalPdp' type='submit' class='button wide'> ENCONTRAR MI TALLA </button> </div> </form> </div> </div> ";  
  }
    body.appendChild(popup);
  toggle(body, 'no-scroll');
  //Con esto evitamos que al clicar la caja se cierre el Pop-Up como ocurre si le damos al fondo de la pantalla
  const boxPopUp = document.getElementsByClassName("box-container")[0];
  //Botón para calcular tu talla
  let boton = document.getElementById('calculateFromModalPdp');
  boton.addEventListener('click', function(){
    calcularCopa($tipo, $color)
  }, false);
  //Cerramos el Pop-Up
  let cerrar = document.getElementById('close');
  let cerrarFondo = document.getElementById('pop-up-container');
  cerrarFondo.addEventListener('click', closePopUp, false);

  boxPopUp.addEventListener('click', function (e){
    e.stopPropagation();
  });

  cerrar.addEventListener('click', closePopUp, false);
}

//Creamos un Pop-Up distinto para los sets (Mostrar tabla con guía de tallas)
function createPopUpSET(tipo) {
  event.preventDefault();
  var popup = document.createElement("div");
  popup.classList.add("pop-up-container");
  popup.id = "pop-up-container";
  if(tipo == 'TOP SWIM & BOTTOM' ){
    popup.innerHTML= " <div class='box-container-set'> <div id='close' class='close'></div> <div class='modalTitle' modal='sizeTool'> <h3 class='dark'>SETS SWIMWEAR</h3> <div class='table-scroll-size'> <table> <tbody> <tr> <th>TOPS</th> <th>EU</th> <th>UK</th> </tr> <tr> <td>S</td> <td>80-85</td> <td>4-6</td> </tr> <tr> <td>M</td> <td>90-95</td> <td>8-10</td> </tr> <tr> <td>L</td> <td>95-100</td> <td>10-12</td> </tr> </tbody> </table> <table> <thead></thead> <tbody> <tr> <th>BOTTOMS</th> <th><strong>EU</strong></th> <th><strong>UK</strong></th> <th><strong>WAIST (CM)</strong></th> <th><strong>HIPS (CM)</strong></th> </tr> </tbody> <tbody> <tr> <td><strong>S</strong></td> <td>32-36</td> <td>2-6</td> <td>60-70</td> <td>90-95</td> </tr> <tr> <td><strong>M</strong></td> <td>38-40</td> <td>8-10</td> <td>70-75</td> <td>95-100</td> </tr> <tr> <td><strong>L</strong</td> <td>40-42</td> <td>10-12</td> <td>75-80</td> <td>100-105</td> </tr> </tbody> </table> </div> </div> </div> ";
    }else{
      popup.innerHTML= " <div class='box-container-set'> <div id='close' class='close'></div> <div class='modalTitle' modal='sizeTool'> <h3 class='dark'>Guía de tallas del SET</h3> <div class='table-scroll-size'> <table> <tbody> <tr> <th>TOPS</th> <th>EU</th> <th>UK</th> </tr> <tr> <td>S</td> <td>80-90</td> <td>4-8</td> </tr> <tr> <td>M</td> <td>95-100</td> <td>10-12</td> </tr> <tr> <td>L</td> <td>100-105</td> <td>12-14</td> </tr> </tbody> </table> <table> <tbody> <tr> <td>BOTTOMS</td> <td>EU</td> <td>UK</td> <td>WAIST (CM)</td> <td>HIPS (CM)</td> </tr> <tr> <td>S</td> <td>32-36</td> <td>2-6</td> <td>60-70</td> <td>90-95</td> </tr> <tr> <td>M</td> <td>38-40</td> <td>8-10</td> <td>70-75</td> <td>95-100</td> </tr> <tr> <td>L</td> <td>40-42</td> <td>10-12</td> <td>75-80</td> <td>100-105</td> </tr> </tbody> </table> </div> </div> </div> ";
    }
  body.appendChild(popup);
  toggle(body, 'no-scroll');

  let cerrar = document.getElementById('close');
  let cerrarFondo = document.getElementById('pop-up-container');
  cerrarFondo.addEventListener('click', closePopUp, false);
  const boxPopUp = document.getElementsByClassName("box-container-set")[0];

  boxPopUp.addEventListener('click', function (e){
    e.stopPropagation();
  }) ;

  cerrar.addEventListener('click', closePopUp, false);
}

//Creamos un Pop-Up distinto para los sets (Mostrar tabla con guía de tallas)
function createPopUpONE() {
  event.preventDefault();
  var popup = document.createElement("div");
  popup.classList.add("pop-up-container");
  popup.id = "pop-up-container";
 
  popup.innerHTML= " <div class='box-container-set'> <div id='close' class='close'></div> <div class='modalTitle' modal='sizeTool'> <h3 class='dark'>Guía de tallas del SET</h3> <div class='table-scroll-size'> <table> <thead></thead> <caption> SETS SWIMWEAR </caption> <tbody> <tr> <th>TOPS</th> <th><strong>EU</strong></th> <th><strong>UK</strong></th> <th><strong>WAIST (CM)</strong></th> <th><strong>HIPS (CM)</strong></th> <th><strong>BUST</strong></th> </tr> </tbody> <tbody> <tr> <td><strong>S</strong></td> <td>34-36</td> <td>4-6</td> <td>60-70</td> <td>90-95</td> <td>80-90</td> </tr> <tr> <td><strong>M</strong></td> <td>36-38</td> <td>6-8</td> <td>70-75</td> <td>95-100</td> <td>90-95</td> </tr> <tr> <td><strong>L</strong</td> <td>38-40</td> <td>8-10</td> <td>75-80</td> <td>100-105</td> <td>95-100</td> </tr> </tbody> </table> </div> </div> </div> ";  
  body.appendChild(popup);
  toggle(body, 'no-scroll');

  let cerrar = document.getElementById('close');
  let cerrarFondo = document.getElementById('pop-up-container');
  cerrarFondo.addEventListener('click', closePopUp, false);
  const boxPopUp = document.getElementsByClassName("box-container-set")[0];

  boxPopUp.addEventListener('click', function (e){
    e.stopPropagation();
  }) ;

  cerrar.addEventListener('click', closePopUp, false);
}

//Funcion para cerrar el Pop-up
function closePopUp() {
  toggle(body, 'no-scroll');  
  document.getElementsByClassName('pop-up-container')[0].remove();
}

function toggle($element, $class){
  $element.classList.toggle($class);
}

//Con esta función calculamos las tallas, recibimos desde el front el color actual y según la talla calculada seleccionamos esa 
//varinte para que al darle a comprar el cliente este preseleccioanda
function calcularCopa($tipo, $color){
let copa = document.getElementById('copa').value;
if($tipo == 'TOP SWIM'){
  //obtenemos la talla del top
  switch(true){
    case (copa == '80-85'):
        document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>S</b></p>";
        setCookie("Talla-TOP-SWIM", 'S', 30);
        //Vamos a obtener los datos de esta variable
        var es = document.querySelectorAll(".product-single__variants")[0];
        for(var i = 0; i < es.length; i++){
          var color =  es[i].innerText.split("/")[0].trim();
          var tallaAux = es[i].innerText.split("/")[1].trim();
          var aux = tallaAux.split("-")[0].trim();
          var talla = aux.split("(")[0].trim();
          var id = es[i].value;
          //datos.push({talla:talla, color: color,id:id});
          if(talla == 'S' && color == $color){
            tallaCalculada($tipo, $color);
            //Vamos a seleccionar la variante para poder comprarla
            var z = document.getElementById("size-selected").innerHTML = "S";	
            var x = document.querySelectorAll(".product-single__variants")[0];
            x.selectedIndex = i;
            if(window.innerWidth > 767){
              var x = document.querySelectorAll(".variant__label")[1];
              x.innerHTML = 'TALLA: <span>S</span>';
            }else{
              var x2 = document.querySelectorAll(".variant__label")[0];
              x2.innerHTML = 'TALLA: <span>S</span>';
            }
            //AniadirCarrito(id);
          }
        }
        break;
    case (copa == '90-95'):
        document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>M</b></p>";
        setCookie("Talla-TOP-SWIM", 'M', 30);
        //Vamos a obtener los datos de esta variable
        var es = document.querySelectorAll(".product-single__variants")[0];
        for(var i = 0; i < es.length; i++){
          var color =  es[i].innerText.split("/")[0].trim();
          var tallaAux = es[i].innerText.split("/")[1].trim();
          var aux = tallaAux.split("-")[0].trim();
          var talla = aux.split("(")[0].trim();
          var id = es[i].value;
          //datos.push({talla:talla, color: color,id:id});
          if(talla == 'M' && color == $color){
            //Vamos a seleccionar la variante para poder comprarla
            var z = document.getElementById("size-selected").innerHTML = "M";	
            var x = document.querySelectorAll(".product-single__variants")[0];
            x.selectedIndex = i;
            if(window.innerWidth > 767){
              var x = document.querySelectorAll(".variant__label")[1];
              x.innerHTML = 'TALLA: <span>M</span>';
            }else{
              var x2 = document.querySelectorAll(".variant__label")[0];
              x2.innerHTML = 'TALLA: <span>M</span>';
            }
            //AniadirCarrito(id);
            tallaCalculada($tipo, $color);
          }
        }
        break;
    case (copa == 'mayor que 95' ):
        document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>L</b></p>";
        setCookie("Talla-TOP-SWIM", 'L', 30);
        //Vamos a obtener los datos de esta variable
        var es = document.querySelectorAll(".product-single__variants")[0];
        for(var i = 0; i < es.length; i++){
          var color =  es[i].innerText.split("/")[0].trim();
          var tallaAux = es[i].innerText.split("/")[1].trim();
          var aux = tallaAux.split("-")[0].trim();
          var talla = aux.split("(")[0].trim();
          var id = es[i].value;
          //datos.push({talla:talla, color: color,id:id});
          if(talla == 'L' && color == $color){
            //Vamos a seleccionar la variante para poder comprarla
            var z = document.getElementById("size-selected").innerHTML = "L";	
            var x = document.querySelectorAll(".product-single__variants")[0];
            x.selectedIndex = i;
            if(window.innerWidth > 767){
              var x = document.querySelectorAll(".variant__label")[1];
              x.innerHTML = 'TALLA: <span>L</span>';
            }else{
              var x2 = document.querySelectorAll(".variant__label")[0];
              x2.innerHTML = 'TALLA: <span>L</span>';
            }
            //AniadirCarrito(id);
            tallaCalculada($tipo, $color);
          }
        }
        break;
    default: 
        document.getElementById("talla-actual").innerHTML = "<p>Talla no válida</p>";
        break;
  }
  }else if ($tipo == 'BOTTOM'){
    //obtenemos la talla del bottom
    switch(true){
      case (copa == '32-34'):
          document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>S</b></p>";
          setCookie("Talla-BOTTOM", 'S', 30);
          //Vamos a obtener los datos de esta variable
          var es = document.querySelectorAll(".product-single__variants")[0];
            for(var i = 0; i < es.length; i++){
            var color =  es[i].innerText.split("/")[0].trim();
            var tallaAux = es[i].innerText.split("/")[1].trim();
            var aux = tallaAux.split("-")[0].trim();
            var talla = aux.split("(")[0].trim();
            var id = es[i].value;
            //datos.push({talla:talla, color: color,id:id});
            if(talla == 'S' && color == $color){
              //Vamos a seleccionar la variante para poder comprarla
              var z = document.getElementById("size-selected").innerHTML = "S";
              var x = document.querySelectorAll(".product-single__variants")[0];
              x.selectedIndex = i;
              if(window.innerWidth > 767){
                var x = document.querySelectorAll(".variant__label")[1];
                x.innerHTML = 'TALLA: <span>S</span>';
              }else{
                var x2 = document.querySelectorAll(".variant__label")[0];
                x2.innerHTML = 'TALLA: <span>S</span>';
              }
              //AniadirCarrito(id);
              tallaCalculada($tipo, $color);
            }
          }
          break;
      case (copa == '36-38'):
          document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>M</b></p>";
          setCookie("Talla-BOTTOM", 'M', 30);
          var x = document.querySelectorAll(".product-single__variants")[0];
          //Vamos a obtener los datos de esta variable
          var es = document.querySelectorAll(".product-single__variants")[0];
            for(var i = 0; i < es.length; i++){
            var color =  es[i].innerText.split("/")[0].trim();
            var tallaAux = es[i].innerText.split("/")[1].trim();
            var aux = tallaAux.split("-")[0].trim();
            var talla = aux.split("(")[0].trim();
            var id = es[i].value;
            //datos.push({talla:talla, color: color,id:id});
            if(talla == 'M' && color == $color){
              //Vamos a seleccionar la variante para poder comprarla
              var z = document.getElementById("size-selected").innerHTML = "M";
              var x = document.querySelectorAll(".product-single__variants")[0];
              x.selectedIndex = i;
              if(window.innerWidth > 767){
                var x = document.querySelectorAll(".variant__label")[1];
                x.innerHTML = 'TALLA: <span>M</span>';
              }else{
                var x2 = document.querySelectorAll(".variant__label")[0];
                x2.innerHTML = 'TALLA: <span>M</span>';
              }
              //AniadirCarrito(id);
              tallaCalculada($tipo, $color);
            }
          }
          break;
      case (copa == '40-42'):
          document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>L</b></p>";
          setCookie("Talla-BOTTOM", 'L', 30);
          var x = document.querySelectorAll(".product-single__variants")[0];
          //Vamos a obtener los datos de esta variable
          var es = document.querySelectorAll(".product-single__variants")[0];
            for(var i = 0; i < es.length; i++){
            var color =  es[i].innerText.split("/")[0].trim();
            var tallaAux = es[i].innerText.split("/")[1].trim();
            var aux = tallaAux.split("-")[0].trim();
            var talla = aux.split("(")[0].trim();
            var id = es[i].value;
            //datos.push({talla:talla, color: color,id:id});
            if(talla == 'L' && color == $color){
              //Vamos a seleccionar la variante para poder comprarla
              var z = document.getElementById("size-selected").innerHTML = "L";
              var x = document.querySelectorAll(".product-single__variants")[0];
              x.selectedIndex = i;
              if(window.innerWidth > 767){
                var x = document.querySelectorAll(".variant__label")[1];
                x.innerHTML = 'TALLA: <span>L</span>';
              }else{
                var x2 = document.querySelectorAll(".variant__label")[0];
                x2.innerHTML = 'TALLA: <span>L</span>';
              }
              //AniadirCarrito(id);
              tallaCalculada($tipo, $color);
            }
          }
          break;
      default: 
          document.getElementById("talla-actual").innerHTML = "<p>Talla no válida</p>";
          break;
    }
  }else if ($tipo == 'SHORTS' || $tipo == 'LEGGINGS'){
    //obtenemos la talla del bottom
    switch(true){
      case (copa == '32-34'):
          document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>S</b></p>";
          setCookie("Talla-BOTTOM", 'S', 30);
          //Vamos a obtener los datos de esta variable
          var es = document.querySelectorAll(".product-single__variants")[0];
            for(var i = 0; i < es.length; i++){
            var color =  es[i].innerText.split("/")[0].trim();
            var tallaAux = es[i].innerText.split("/")[1].trim();
            var talla = tallaAux.split("-")[0].trim();
            var id = es[i].value;
            //datos.push({talla:talla, color: color,id:id});
            if(talla == 'S' && color == $color){
              //Vamos a seleccionar la variante para poder comprarla
              var z = document.getElementById("size-selected").innerHTML = "S";
              var x = document.querySelectorAll(".product-single__variants")[0];
              x.selectedIndex = i;
              if(window.innerWidth > 767){
                var x = document.querySelectorAll(".variant__label")[1];
                x.innerHTML = 'TALLA: <span>S</span>';
              }else{
                var x2 = document.querySelectorAll(".variant__label")[0];
                x2.innerHTML = 'TALLA: <span>S</span>';
              }
              //AniadirCarrito(id);
              tallaCalculada($tipo, $color);
            }
          }
          break;
      case (copa == '36-38'):
          document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>M</b></p>";
          setCookie("Talla-BOTTOM", 'M', 30);
          var x = document.querySelectorAll(".product-single__variants")[0];
          //Vamos a obtener los datos de esta variable
          var es = document.querySelectorAll(".product-single__variants")[0];
            for(var i = 0; i < es.length; i++){
            var color =  es[i].innerText.split("/")[0].trim();
            var tallaAux = es[i].innerText.split("/")[1].trim();
            var talla = tallaAux.split("-")[0].trim();
            var id = es[i].value;
            //datos.push({talla:talla, color: color,id:id});
            if(talla == 'M' && color == $color){
              //Vamos a seleccionar la variante para poder comprarla
              var z = document.getElementById("size-selected").innerHTML = "M";
              var x = document.querySelectorAll(".product-single__variants")[0];
              x.selectedIndex = i;
              if(window.innerWidth > 767){
                var x = document.querySelectorAll(".variant__label")[1];
                x.innerHTML = 'TALLA: <span>M</span>';
              }else{
                var x2 = document.querySelectorAll(".variant__label")[0];
                x2.innerHTML = 'TALLA: <span>M</span>';
              }
              //AniadirCarrito(id);
              tallaCalculada($tipo, $color);
            }
          }
          break;
      case (copa == '40-42'):
          document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>L</b></p>";
          setCookie("Talla-BOTTOM", 'L', 30);
          var x = document.querySelectorAll(".product-single__variants")[0];
          //Vamos a obtener los datos de esta variable
          var es = document.querySelectorAll(".product-single__variants")[0];
            for(var i = 0; i < es.length; i++){
            var color =  es[i].innerText.split("/")[0].trim();
            var tallaAux = es[i].innerText.split("/")[1].trim();
            var talla = tallaAux.split("-")[0].trim();
            var id = es[i].value;
            //datos.push({talla:talla, color: color,id:id});
            if(talla == 'L' && color == $color){
              //Vamos a seleccionar la variante para poder comprarla
              var z = document.getElementById("size-selected").innerHTML = "L";
              var x = document.querySelectorAll(".product-single__variants")[0];
              x.selectedIndex = i;
              if(window.innerWidth > 767){
                var x = document.querySelectorAll(".variant__label")[1];
                x.innerHTML = 'TALLA: <span>L</span>';
              }else{
                var x2 = document.querySelectorAll(".variant__label")[0];
                x2.innerHTML = 'TALLA: <span>L</span>';
              }
              //AniadirCarrito(id);
              tallaCalculada($tipo, $color);
            }
          }
          break;
      default: 
          document.getElementById("talla-actual").innerHTML = "<p>Talla no válida</p>";
          break;
    }
  }else if($tipo == 'TOP ACTIVE'){
    //obtenemos la talla del top
    switch(true){
      case (copa == '80-90'):
          document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>S</b></p>";
          setCookie("Talla-TOP-ACTIVE", 'S', 30);

          //Vamos a obtener los datos de esta variable
          var es = document.querySelectorAll(".product-single__variants")[0];
            for(var i = 0; i < es.length; i++){
            var color =  es[i].innerText.split("/")[0].trim();
            var tallaAux = es[i].innerText.split("/")[1].trim();
            var talla = tallaAux.split("-")[0].trim();
            var id = es[i].value;
            //datos.push({talla:talla, color: color,id:id});
            if(talla == 'S' && color == $color){
              //Vamos a seleccionar la variante para poder comprarla
              var z = document.getElementById("size-selected").innerHTML = "S";
              var x = document.querySelectorAll(".product-single__variants")[0];
              x.selectedIndex = i;
              if(window.innerWidth > 767){
                var x = document.querySelectorAll(".variant__label")[1];
                x.innerHTML = 'TALLA: <span>S</span>';
              }else{
                var x2 = document.querySelectorAll(".variant__label")[0];
                x2.innerHTML = 'TALLA: <span>S</span>';
              }
              //AniadirCarrito(id);
              tallaCalculada($tipo, $color);
            }
          }
          
          break;
      case (copa == '95-100'):
          document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>M</b></p>";
          setCookie("Talla-TOP-ACTIVE", 'M', 30);
          //Vamos a obtener los datos de esta variable
          var es = document.querySelectorAll(".product-single__variants")[0];
            for(var i = 0; i < es.length; i++){
            var color =  es[i].innerText.split("/")[0].trim();
            var tallaAux = es[i].innerText.split("/")[1].trim();
            var talla = tallaAux.split("-")[0].trim();
            var id = es[i].value;
            //datos.push({talla:talla, color: color,id:id});
            if(talla == 'M' && color == $color){
              //Vamos a seleccionar la variante para poder comprarla
              var z = document.getElementById("size-selected").innerHTML = "M";
              var x = document.querySelectorAll(".product-single__variants")[0];
              x.selectedIndex = i;
              if(window.innerWidth > 767){
                var x = document.querySelectorAll(".variant__label")[1];
                x.innerHTML = 'TALLA: <span>M</span>';
              }else{
                var x2 = document.querySelectorAll(".variant__label")[0];
                x2.innerHTML = 'TALLA: <span>M</span>';
              }
              //AniadirCarrito(id);
              tallaCalculada($tipo, $color);
            }
          }
          break;
      case (copa == 'mayor que 100' ):
          document.getElementById("talla-actual").innerHTML = "<p>TU TALLA ES LA: <b>L</b></p>";
          setCookie("Talla-TOP-ACTIVE", 'L', 30);
          //Vamos a obtener los datos de esta variable
          var es = document.querySelectorAll(".product-single__variants")[0];
            for(var i = 0; i < es.length; i++){
            var color =  es[i].innerText.split("/")[0].trim();
            var tallaAux = es[i].innerText.split("/")[1].trim();
            var talla = tallaAux.split("-")[0].trim();
            var id = es[i].value;
            //datos.push({talla:talla, color: color,id:id});
            if(talla == 'L' && color == $color){
              console.log(i);  
              //Vamos a seleccionar la variante para poder comprarla
              var z = document.getElementById("size-selected").innerHTML = "L";
              var x = document.querySelectorAll(".product-single__variants")[0];
              x.selectedIndex = i;
              if(window.innerWidth > 767){
                var x = document.querySelectorAll(".variant__label")[1];
                x.innerHTML = 'TALLA: <span>L</span>';
              }else{
                var x2 = document.querySelectorAll(".variant__label")[0];
                x2.innerHTML = 'TALLA: <span>L</span>';
              }
              //AniadirCarrito(id);
              tallaCalculada($tipo, $color);
            }
          }
          break;
      default: 
          document.getElementById("talla-actual").innerHTML = "<p>Talla no válida</p>";
          break;
    }
  }
}

//Cookies
function setCookie(cname,cvalue,exdays) {
const d = new Date();
d.setTime(d.getTime() + (exdays*24*60*60*1000));
let expires = "expires=" + d.toGMTString();
document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
let name = cname + "=";
let decodedCookie = decodeURIComponent(document.cookie);
let ca = decodedCookie.split(';');
for(let i = 0; i < ca.length; i++) {
  let c = ca[i];
  while (c.charAt(0) == ' ') {
    c = c.substring(1);
  }
  if (c.indexOf(name) == 0) {
    return c.substring(name.length, c.length);
  }
}
return "";
}

//Función para modificar el botón tras calcular la talla 
function tallaCalculada($tipo, $color) {
  //alert("va");
  var e = document.getElementById("calculateFromModalPdp");
  e.innerHTML = "<button id='comprar-button' type='submit' class='button wide'>COMENZAR DE NUEVO</button>" ;
  e.addEventListener('click', function(){
    borrar($tipo, $color);

  }, false);
}

//Función para borrar el PopUp
function borrar($tipo, $color) {
  var borrarP = document.getElementById('talla-actual');
  borrarP.innerHTML= "";
  
  var borrarP2 = document.getElementsByClassName('selecciona-talla')[0];
  borrarP2.innerHTML= "";

  var e = document.getElementById("calculateFromModalPdp");
  e.innerHTML = "<button id='calculateFromModalPdp' type='submit' class='button wide'>ENCONTRAR MI TALLA </button>" ;
  let boton = document.getElementById('calculateFromModalPdp');
  boton.addEventListener('click', function(){
    calcularCopa($tipo, $color);
    var mostrarP = document.getElementsByClassName('selecciona-talla')[0];
    mostrarP.innerHTML= "<p>SELECCIONA TU TALLA DE PECHO</p>";
      //Desactrivamos el desplegable de tallas al clicar el botón
      var eleman2 = document.getElementById('copa');
      eleman2.disabled = true;
  }, false);
  //Activamos el desplegable de tallas para poder calcularla
  var eleman = document.getElementById('copa');
  eleman.disabled = false;

}

function AniadirCarrito(id) {
  var e = document.getElementById("calculateFromModalPdp");
  e.innerHTML = "<button id='comprar-button' type='submit' class='button wide'>AÑADIR AL CARRITO</button>" ;
  e.addEventListener('click', function(){
    comprar(id);
  }, false);
}


function comprar(datos){
  console.log('variante: ' + datos)
  let formData = {
    'items': [{
     'id': datos,
     'quantity': 1
     }]
   }
   fetch('/cart/add.js', {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json'
     },
     body: JSON.stringify(formData)
   })
   .then(response => {
     return response.json();
   })
   .catch((error) => {
     console.error('Error:', error);
   });
   recuperarItemsCarrito();
}

function recuperarItemsCarrito() {
  var cantidad = 0;
  fetch('/cart.js')
    .then(function (response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
    })
    .then(function (responseAsObject) {
      cantidad = 0;
      for(var i = 0; i < responseAsObject.items.length; i++){
        cantidad += responseAsObject.items[i].quantity+1;
      }
      var carrito = document.getElementsByClassName("cart-link__bubble")[0];
      carrito.classList.add("cart-link__bubble--visible");
      carrito.innerHTML = cantidad;
    })
    .catch(function (error) {
        console.log('Ha habido un problema: ', error);
    });
}

function checkCookie(tipo, datos) {
  var talla = '';
  let user = "";
  //Si es Set muestro guía de tallas 
  if(tipo.includes('TOP SWIM & BOTTOM')){
    createPopUpSET('TOP SWIM & BOTTOM');
  }else if(tipo.includes('TOP ACTIVE & ')){
    createPopUpSET('TOP ACTIVE');
  }else if(tipo.includes('ONE PIECE')){
    createPopUpONE();
  }else{
    //Al no ser de tipo set permito elegir a los usurios una talla
    if(tipo == 'TOP SWIM'){
      user = getCookie("Talla-TOP-SWIM");
    }else if(tipo == 'BOTTOM' || tipo == 'SHORTS' || tipo == 'LEGGINGS'){
      user = getCookie("Talla-BOTTOM");
    }else if(tipo == 'TOP ACTIVE'){
      user = getCookie("Talla-TOP-ACTIVE");
    }
    if (user != "") {
      talla = '<p>TU TALLA ES LA: ' + '<b>' + user + '</b></p>';
      if(window.innerWidth > 767){
        var x = document.querySelectorAll(".color_active")[1];
        var color  = x.innerText;
        createPopUp(talla, tipo,color);
        //Desactivamos el inmput de las tallas 
        var eleman = document.getElementById('copa');
        eleman.disabled = true;
        var e = document.getElementById("calculateFromModalPdp");
        e.innerHTML = "<button id='comprar-button' type='submit' class='button wide'>COMENZAR DE NUEVO</button>" ;
        e.addEventListener('click', function(){
          borrar(tipo, color);
          var mostrarP = document.getElementsByClassName('selecciona-talla')[0];
          mostrarP.innerHTML= "<p>SELECCIONA TU TALLA DE PECHO</p>";
        }, false);

      }else{
        var x = document.querySelectorAll(".select-color")[0];
        var color  = x.value;
        createPopUp(talla, tipo,color);
        //Desactivamos el inmput de las tallas 
        var eleman = document.getElementById('copa');
        eleman.disabled = true;
        var e = document.getElementById("calculateFromModalPdp");
        e.innerHTML = "<button id='comprar-button' type='submit' class='button wide'>COMENZAR DE NUEVO</button>" ;
        e.addEventListener('click', function(){
          borrar(tipo, color);
          var mostrarP = document.getElementsByClassName('selecciona-talla')[0];
          mostrarP.innerHTML= "<p>SELECCIONA TU TALLA DE PECHO</p>";
        }, false);
      }
    }else{
      if(window.innerWidth > 767){
        var x = document.querySelectorAll(".color_active")[1];
        var color  = x.innerText;
        createPopUp(talla, tipo, color);
      }else{
        var x = document.querySelectorAll(".select-color")[0];
        var color  = x.value;
        createPopUp(talla, tipo,color);


      }
    }
  }

  //Función para poder realizar compras directamente desde el Pop-Up
  //comprar(datos);

}
